/**
 * Recent Transactions Component
 * - Displays list of recent payment transactions
 * - Shows transaction amounts, dates, and user information
 * - Links to detailed transaction views
 */

import React from "react";
import { IoIosArrowForward } from "react-icons/io";

const items = [
  {
    status: "Completed",
    method: "Visa card **** 4831",
    sub: "Card payment",
    amount: "$182.94",
    date: "Jan 17, 2022",
  },
  {
    status: "Completed",
    method: "Mastercard **** 6442",
    sub: "Card payment",
    amount: "$99.00",
    date: "Jan 17, 2022",
  },
  {
    status: "Pending",
    method: "Account ****8892",
    sub: "Bank payment",
    amount: "$249.94",
    date: "Jan 17, 2022",
  },
  {
    status: "Canceled",
    method: "Amex card **** 5666",
    sub: "Card payment",
    amount: "$189.24",
    date: "Jan 17, 2022",
  },
];

const StatusPill = ({ s }) => {
  const map = {
    Completed: "bg-emerald-50 text-emerald-700",
    Pending: "bg-amber-50 text-amber-700",
    Canceled: "bg-rose-50 text-rose-700",
  };
  return (
    <span className={`rounded-md px-2 py-0.5 text-xs font-medium ${map[s] || "bg-gray-100 text-gray-700"}`}>
      {s}
    </span>
  );
};

export default function TransactionsList() {
  return (
    <div className="w-full border-gray-300 border p-3 sm:p-4 py-4 sm:py-5 rounded-lg">
      <div className="mb-4 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
        <div>
          <h3 className="text-sm sm:text-base font-semibold text-gray-900">Transactions</h3>
          <p className="mt-1 text-xs text-gray-500">
            Lorem ipsum dolor sit amet, consectetur adipisi.
          </p>
        </div>

        <button className="flex items-center gap-1 text-xs sm:text-sm font-medium text-blue-600 hover:underline self-start sm:self-auto">
          See All Transactions <IoIosArrowForward className="w-3 h-3 sm:w-4 sm:h-4" />
        </button>
      </div>

      <ul className="divide-y divide-gray-100">
        {items.map((t, i) => (
          <li key={i} className="flex items-center justify-between py-3 gap-2">
            <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
              <StatusPill s={t.status} />
              <div className="min-w-0 flex-1">
                <div className="text-xs sm:text-sm font-medium text-gray-900 truncate">{t.method}</div>
                <div className="text-xs text-gray-500">{t.sub}</div>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="text-xs sm:text-sm font-semibold text-gray-900">{t.amount}</div>
              <div className="text-xs text-gray-400">{t.date}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
